import { Controller } from "@hotwired/stimulus"

// Allows individual variants to be collapsed to just their header row.
// State persists in localStorage so collapsed variants stay collapsed
// across page loads and form submissions.
//
// Usage:
//   <div data-controller="variant-collapse" data-variant-collapse-id-value="var-abc123">
//     <div data-variant-collapse-target="header" data-action="click->variant-collapse#toggle">
//       ... always-visible header ...
//     </div>
//     <div data-variant-collapse-target="body">
//       ... collapsible content ...
//     </div>
//   </div>
//
export default class extends Controller {
  static values = { id: String }
  static targets = ["body"]

  connect() {
    if (this.isCollapsed) {
      this.bodyTargets.forEach((el) => (el.hidden = true))
    }
  }

  toggle() {
    const collapsed = !this.isCollapsed
    this.bodyTargets.forEach((el) => (el.hidden = collapsed))

    if (collapsed) {
      localStorage.setItem(this.storageKey, "1")
    } else {
      localStorage.removeItem(this.storageKey)
    }
  }

  get isCollapsed() {
    return localStorage.getItem(this.storageKey) === "1"
  }

  get storageKey() {
    return `variant-collapsed-${this.idValue}`
  }
}
